export const SUPER_SEARCH_TEST_IDS = {
  dialog: 'super-search__dialog',
  empty: 'super-search__empty',
  error: 'super-search__error',
  input: 'super-search__input',
  instructions: 'super-search__instructions',
  loading: 'super-search__loading',
  navigation: 'super-search__navigation',
  partialError: 'super-search__partial-error',
  result: (resultId: string) => `super-search__result-${resultId}`,
  results: 'super-search__results',
  retry: 'super-search__retry',
  sectionLabel: (sectionId: string) => `super-search__section-${sectionId}`,
  status: 'super-search__status',
} as const;
